import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    width: 290,
    minHeight: 600,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
    }
  },
  pushRight: {
    marginRight: theme.spacing(1)
  },
  pushDown: {
    marginBottom: theme.spacing(1)
  }
}))